import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingSignatureBackgroundRemoverConfig } from '@/data/landingConfig/landingSignatureBackgroundRemoverConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_SignatureBackgroundRemover } from './schemaObject';

interface Props {}
const SignatureBackgroundRemover: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_SignatureBackgroundRemover} />
			<LandingTemplate
				data={landingSignatureBackgroundRemoverConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default SignatureBackgroundRemover;
